import { useEffect, useState } from "react";
import { Col, Row, Space, Spin } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import {
  fetchRaceList,
  fetchRolesList,
  fetchVeteranStatusList,
  fetchEducationLevelsList,

} from "../../../../../store/CommonSlice";

import { fetchList as fetchCompanyList } from "../../../Company/utils/slice";
import { CONSTANT, genderOptions, CUSTOMER_ROLE } from "../../../../../config/Constant";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../utils/hooks/hooks";
import dayjs from "dayjs";
import { validations } from "../../../../../config/validations/validations";
import { formatMobileNumber } from "../../../../../utils/commonFunctions";
import { formRules } from "../../../../../config/validations/formRules";
import { dateFormats } from "../../utils/constats";
import { RootState } from "../../../../../store/app";
import { resetsUserExam, setUserSpecialFlag } from "../../utils/slice";
/**
 * Renders a form component for user management module for creating and editing.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form object.
 * @param {string} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle form value changes.
 * @param {Object} props.editValues - The values to edit in the form.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  const { rolesList, raceList, veteranStatusList } = useAppSelector(
    (state) => state.common
  );

  const [result, setResult] = useState<any>();
  const [pinCode, setPinCode] = useState<any>();
  const [stateDetail, setStateDetail] = useState<any>([]);
  const [selectOk, setSelectOk] = useState<number>(0);
  const [list, setList] = useState<any>();
  const [pinCodeFinal, state] = stateDetail;
  const [isPlacePredictionsLoading, setIsPlacePredictionsLoading] =
    useState(false);
  const [educationLevelList, setEducationLevelList] = useState([]);
  const [latLng, setLatLng] = useState<{ lat: number; lng: number }>();

  const {
    dob,
    race_id,
    veteran_status_id,
    // decline_to_answer_disabilities,
    // decline_to_answer_gender,
    // decline_to_answer_race_id,
    // decline_to_answer_household_income,
    // decline_to_answer_veteran_status,
    role_id,
  } = editValues ?? {};

  const dispatch = useAppDispatch();




  const getCityName = (result: any) => {
    // 1. Check if results exist and have at least one entry
    if (!result) return '';

    // 2. Get the address components from the first (most accurate) result
    const components = result.address_components;

    // 3. Find the component where the types array includes "locality"
    // Fallbacks: "sublocality_level_1" (for NYC) or "postal_town" (for UK)
    const cityComponent = components.find((c: any) =>
      c.types.includes("locality") ||
      c.types.includes("sublocality_level_1") ||
      c.types.includes("postal_town")
    );

    // 4. Return the long_name (e.g., "New York") or null
    return cityComponent ? cityComponent.long_name : '';
  };


  /**
 * Extracts Latitude and Longitude from a Google Maps Geocode response.
 * Works with both the JS SDK and direct JSON API responses.
 */
  const getLatLng = (result: any) => {
    if (!result || !result.geometry) {
      return null;
    }

    const location = result.geometry.location;

    // Handle both SDK function calls and raw JSON properties
    const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
    const lng = typeof location.lng === 'function' ? location.lng() : location.lng;

    return {
      lat: Number(lat),
      lng: Number(lng)
    };
  };

  useEffect(() => {
    dispatch(fetchRolesList()).catch((error: any) => error);
    dispatch(fetchRaceList()).catch((error: any) => error);
    dispatch(fetchVeteranStatusList()).catch((error: any) => error);
    dispatch(fetchEducationLevelsList()).then((response: any) => {
      setEducationLevelList(response);
    }).catch((error: any) => error);
  }, []);

  const userInterestAssessmentDetail: any = useAppSelector(
    (state: RootState) => state.auth.initialData
  );

  useEffect(() => {
    if (editValues) {
      form.setFieldsValue({
        ...editValues,
        dob: dob && dayjs(dob),
        race: race_id,
        disabilities: editValues.disabilities?.id,
        house_hold_income: editValues.house_hold_income?.id,
        veteran_status: veteran_status_id,
        // decline_to_answer_disabilities: [decline_to_answer_disabilities],
        // decline_to_answer_gender: [decline_to_answer_gender],
        // decline_to_answer_race_id: [decline_to_answer_race_id],
        // decline_to_answer_household_income: [
        //   decline_to_answer_household_income,
        // ],
        // decline_to_answer_veteran_status: [decline_to_answer_veteran_status],
        company_id: editValues.company?.id,
        education_level: editValues.education_level ? Number(editValues.education_level) : null,
        year_of_experience: editValues.year_of_experience ? Number(editValues.year_of_experience) : null,
      });
      if (editValues?.location) {
        setPinCode(editValues?.location);
        setStateDetail([Number(editValues?.location), editValues?.state]);
        setLatLng({
          lat: Number(editValues?.longitude),
          lng: Number(editValues?.latitude),
        });
      }
    }
  }, [editValues]);

  // code for fetching state detail from zip code : start

  useEffect(() => {
    const onlyContainsNumbers = (pinCode: any) => /^\d+$/.test(pinCode);

    if (onlyContainsNumbers(pinCode)) {
      setIsPlacePredictionsLoading(true);
      const geocoder: google.maps.Geocoder | any = new google.maps.Geocoder();

      if (google.maps) {
        const geoCode: any = (request: google.maps.GeocoderRequest): void => {
          if (geocoder.geocode(request) != undefined) {
            geocoder
              .geocode(request)
              .then((result: any) => {
                setResult(result);
              })
              .catch(() => {
                console.log("GeoCode not found");
              });
          }
        }
        geoCode({ address: pinCode });
      }
    }
    if (pinCode?.length === 0) {
      setList([]), setResult([]);
    }
  }, [pinCode]);

  useEffect(() => {
    if (Array.isArray(result?.results)) {
      const mappedList = result?.results.map((data: any, index: number) => ({
        id: index + 1,
        name: data.formatted_address,
      }));
      setList(mappedList);
      setIsPlacePredictionsLoading(false);
    }
  }, [result]);

  useEffect(() => {
    if (selectOk !== 0 && result.results) {
      const details = result?.results[selectOk - 1]?.address_components;
      setStateDetail([
        details?.[0]?.long_name,
        details?.[details.length - 2]?.long_name,
      ]);
      form.setFieldsValue({ location: details?.[0]?.long_name });

      let city = getCityName(result?.results[selectOk - 1]);
      form.setFieldsValue({ city: (city || '') })

      let locationdata = getLatLng(result?.results[selectOk - 1]);
      setLatLng({
        lat: Number(locationdata?.lat),
        lng: Number(locationdata?.lng),
      });



    }
  }, [selectOk]);

  // code for fetching state detail from zip code : End

  const minDate = dayjs().subtract(13, "years");
  const disableDate = (current: any) => {
    return current && current > minDate;
  };

  const [roleId, setRoleId] = useState<number>(role_id);
  const [companyList, setCompanyList] = useState<any>([]);



  useEffect(() => {
    setCompanyList([]);
    if (roleId == 3) {
      dispatch(fetchCompanyList())
        .then((data: any) => {
          setCompanyList(data.rows);
        })
        .catch((error: any) => error);
    }
  }, [roleId]);

  const [genderCheck, setGenderCheck] = useState("0");
  const [disabilitiesCheck, setDisabilitiesCheck] = useState("0");
  const [EthnicityCheck, setEthnicityCheck] = useState("0");

  const [houseHold, setHouseHold] = useState("0");

  const [veteranStatusCheck, setVeteranStatusCheck] = useState("0");

  // Process the form data and handle the form submission.
  const onFinish = (data: any) => {
    data.dob = dayjs(data.dob).format(CONSTANT.POST_DATE_FORMAT);
    // data.decline_to_answer_disabilities =
    //   data.decline_to_answer_disabilities?.length > 0
    //     ? data.decline_to_answer_disabilities[0]
    //     : 0;
    // data.decline_to_answer_gender =
    //   data.decline_to_answer_gender?.length > 0
    //     ? data.decline_to_answer_gender[0]
    //     : 0;
    // data.decline_to_answer_race_id =
    //   data.decline_to_answer_race_id?.length > 0
    //     ? data.decline_to_answer_race_id[0]
    //     : 0;
    // data.decline_to_answer_household_income =
    //   data.decline_to_answer_household_income?.length > 0
    //     ? data.decline_to_answer_household_income[0]
    //     : 0;
    // data.decline_to_answer_veteran_status =
    //   data.decline_to_answer_veteran_status?.length > 0
    //     ? data.decline_to_answer_veteran_status[0]
    //     : 0;
    data.location = Number(pinCodeFinal);
    data.state = state;
    data.latitude = latLng?.lat;
    data.longitude = latLng?.lng;
    // console.log(editValues,);

    if (editValues) {
      if (
        (
          editValues?.interest_assessment_exam_status == 1 ||
          editValues?.skill_assessment_exam_status == 1
        ) &&
        (
          data.education_level != editValues?.education_level ||
          data.year_of_experience != editValues?.year_of_experience
        )) {

        dispatch(resetsUserExam(editValues.id)).catch((error: any) => error);
      }
      else {
        if (
          data.education_level != editValues?.education_level ||
          data.year_of_experience != editValues?.year_of_experience
        ) {
          var specialProfileFlagRequest = {
            user_id: editValues.id,
            flag: 1,
            type: 2
          }
          dispatch(setUserSpecialFlag(specialProfileFlagRequest))
        }
      }
    }
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Space direction="vertical" size="large">
          <Row gutter={[15, 15]}>
            <>
              <br />
              <br />
              <Col xs={{ span: 24 }}>
                <b>User Details:</b>
              </Col>
              <br />
              <br />
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Text
                  required
                  label="First Name"
                  name="name"
                  rules={rules.name()}
                />
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Text
                  required
                  label="Last Name"
                  name="last_name"
                  rules={rules.last_name()}
                />
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Text
                  label="Mobile Number"
                  name="mobile_no"
                  maxLength={10}
                  placeholder="000-000-0000"
                  rules={formRules.mobileNumber()}
                  onChange={(e: any) => {
                    if (e.target.value.length > 0) {
                      form.setFieldsValue({
                        mobile_no: formatMobileNumber(e.target.value),
                      });
                    }
                  }}
                />
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Text
                  required
                  name="email"
                  label="Email"
                  rules={rules.email()}
                  disabled={editValues ? true : false}
                />
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Select
                  required
                  label="Role"
                  name="role_id"
                  showSearch
                  className="singleSelect"
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                  options={{
                    list: editValues && editValues.role_id == CUSTOMER_ROLE ? rolesList : rolesList.filter((role: any) => role.id != 3),
                    valueKey: "id",
                    textKey: "name",
                  }}
                  onChange={(e: any) => setRoleId(e)}
                  disabled={editValues && editValues.role_id == CUSTOMER_ROLE}
                />
              </Col>
              {!editValues && (
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  <InputBox.Password
                    required
                    name="password"
                    label="Password"
                    rules={rules.password()}
                  />
                </Col>
              )}
            </>
          </Row>
          <Row gutter={[15, 15]}>
            {![1, 3].includes(roleId) && (
              <>
                <br />
                <br />
                <Col xs={{ span: 24 }}>
                  <b>Demographic Information:</b>
                </Col>
                <br />
                <br />
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  <InputBox.DatePicker
                    required
                    label="Date of birth"
                    name="dob"
                    format={dateFormats.dob}
                    rules={rules.dateOfBirth()}
                    disabledDate={disableDate}
                    defaultPickerValue={minDate}
                  />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  {/* <InputBox.Checkbox
                  noStyle
                  name="decline_to_answer_gender"
                  options={{
                    list: [
                      {
                        id: 1,
                        name: "Decline to answer",
                      },
                    ],
                  }}
                  onChange={(e: any) => {
                    form.validateFields();
                    setGenderCheck(
                      e[0] === "0" || e[0] === undefined ? "0" : "1"
                    );
                    if (Number(genderCheck) === 0) {
                      form.setFieldsValue({ gender: null });
                    }
                  }}
                /> */}
                  <InputBox.Select
                    allowClear
                    name="gender"
                    showSearch
                    className="singleSelect"
                    label="Gender"
                    optionFilterProp="children"
                    disabled={genderCheck === "1"}
                    filterOption={(input, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Gender"
                    rules={
                      genderCheck === "1" ? [] : [validations.required.select()]
                    }
                    options={{
                      list: userInterestAssessmentDetail?.gender,
                      valueKey: "id",
                      textKey: "name",
                    }}
                  />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  {/* <InputBox.Checkbox
                  noStyle
                  label="Decline to answer"
                  name="decline_to_answer_race_id"
                  options={{
                    list: [
                      {
                        id: 1,
                        name: "Decline to answer",
                      },
                    ],
                  }}
                  onChange={(e: any) => {
                    form.validateFields();
                    setEthnicityCheck(
                      e[0] === "0" || e[0] === undefined ? "0" : "1"
                    );
                    if (Number(EthnicityCheck) === 0) {
                      form.setFieldsValue({ race_id: null });
                    }
                  }}
                /> */}
                  <InputBox.Select
                    allowClear
                    name="race_id"
                    label="Ethnicity"
                    placeholder="Select Ethnicity"
                    showSearch
                    className="singleSelect"
                    disabled={EthnicityCheck === "1"}
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    rules={
                      EthnicityCheck === "1"
                        ? []
                        : [validations.required.select()]
                    }
                    options={{
                      list: raceList,
                      valueKey: "id",
                      textKey: "name",
                    }}
                  />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  {/* <InputBox.Checkbox
                  noStyle
                  name="decline_to_answer_disabilities"
                  label="Decline to answer"
                  options={{
                    list: [
                      {
                        id: 1,
                        name: "Decline to answer",
                      },
                    ],
                  }}
                  onChange={(e: any) => {
                    form.validateFields();
                    setDisabilitiesCheck(
                      e[0] === "0" || e[0] === undefined ? "0" : "1"
                    );
                    if (Number(disabilitiesCheck) === 0) {
                      form.setFieldsValue({ disabilities: null });
                    }
                  }}
                /> */}

                  <InputBox.Select
                    allowClear
                    name="disabilities"
                    label="Disability Status"
                    placeholder="Disability Status"
                    showSearch
                    className="singleSelect"
                    disabled={disabilitiesCheck === "1"}
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    rules={
                      disabilitiesCheck === "1"
                        ? []
                        : [validations.required.select()]
                    }
                    options={{
                      list: userInterestAssessmentDetail?.disability_status,
                      valueKey: "id",
                      textKey: "name",
                    }}
                  />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  {/* <InputBox.Checkbox
                  noStyle
                  label="Decline to answer"
                  name="decline_to_answer_veteran_status"
                  options={{
                    list: [
                      {
                        id: 1,
                        name: "Decline to answer",
                      },
                    ],
                  }}
                  onChange={(e: any) => {
                    form.validateFields();
                    setVeteranStatusCheck(
                      e[0] === "0" || e[0] === undefined ? "0" : "1"
                    );
                    if (Number(veteranStatusCheck) === 0) {
                      form.setFieldsValue({ veteran_status: null });
                    }
                  }}
                /> */}
                  <InputBox.Select
                    name="veteran_status"
                    placeholder="Select Military Status"
                    showSearch
                    className="singleSelect"
                    label="Military Status"
                    disabled={veteranStatusCheck === "1"}
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    rules={
                      veteranStatusCheck === "1"
                        ? []
                        : [validations.required.select()]
                    }
                    options={{
                      list: veteranStatusList,
                      valueKey: "id",
                      textKey: "name",
                    }}
                    allowClear
                  />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  {/* <InputBox.Checkbox
                  noStyle
                  name="decline_to_answer_household_income"
                  options={{
                    list: [
                      {
                        id: 1,
                        name: "Decline to answer",
                      },
                    ],
                  }}
                  onChange={(e: any) => {
                    form.validateFields();
                    setHouseHold(
                      e[0] === "0" || e[0] === undefined ? "0" : "1"
                    );
                    if (Number(houseHold) === 0) {
                      form.setFieldsValue({ house_hold_income: null });
                    }
                  }}
                /> */}

                  <InputBox.Select
                    allowClear
                    name="house_hold_income"
                    showSearch
                    className="singleSelect"
                    label="Household Income"
                    disabled={houseHold === "1"}
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Select Household Income"
                    rules={
                      houseHold === "1" ? [] : [validations.required.select()]
                    }
                    options={{
                      list: userInterestAssessmentDetail?.annual_income,
                      valueKey: "id",
                      textKey: "name",
                    }}
                  />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  <InputBox.Select
                    allowClear
                    className="singleSelect"
                    name="location"
                    rules={rules.zipCode()}
                    label="Location (Zip Code)"
                    placeholder="Search Location (Zip Code)"
                    onKeyUp={() => {
                      setTimeout(() => {
                        setIsPlacePredictionsLoading(false);
                      }, 2000);
                    }}
                    showSearch
                    onSearch={(value: any) => {
                      setSelectOk(0)
                      setPinCode(value);
                    }}
                    notFoundContent={
                      isPlacePredictionsLoading ? (
                        <Spin size="default" />
                      ) : (
                        "No Place Found."
                      )
                    }
                    optionFilterProp="children"
                    onSelect={(e) => {
                      setSelectOk(e);
                    }}
                    onClear={() => (
                      setList([]),
                      setStateDetail([]),
                      setSelectOk(0),
                      form.setFieldsValue({ city: '' }),
                      setLatLng({
                        lat: 0,
                        lng: 0,
                      })
                    )}
                    options={{
                      list: list,

                    }}
                  />
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  <InputBox.Text
                    name="city"
                    label="City"
                    disabled={true}
                  />
                </Col>


              </>
            )}

            {roleId == 3 && (
              <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 12 }}>
                <InputBox.Select
                  required
                  label="Customer"
                  name="company_id"
                  showSearch
                  className="singleSelect"
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                  options={{
                    list: companyList,
                    valueKey: "id",
                    textKey: "company_name",
                  }}
                />
              </Col>

            )}


          </Row>
          {![1, 3].includes(roleId) &&
            <Row gutter={[15, 15]}>
              <br />
              <br />
              <Col xs={{ span: 24 }}>
                <b>Background Information:</b>
                <p>Modifying education or experience level will clear current exam progress.</p>
              </Col>
              <br />
              <br />
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Select
                  allowClear
                  name="willing_to_relocate"
                  showSearch
                  className="singleSelect"
                  label="Willing to Relocate?"
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select Willing to Relocate"
                  rules={[validations.required.select()]}
                  options={{
                    list: [{ id: 1, name: 'Yes' }, { id: 0, name: 'No' }],
                    valueKey: "id",
                    textKey: "name",
                  }}
                />
              </Col>

              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Select
                  allowClear
                  name="education_level"
                  showSearch
                  className="singleSelect"
                  label="Education Level"
                  // disabled={houseHold === "1"}
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select Education Level"
                  rules={[validations.required.select()]}
                  options={{
                    list: userInterestAssessmentDetail?.profile_education_level,
                    valueKey: "id",
                    textKey: "name",
                  }}
                />
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <InputBox.Select
                  allowClear
                  name="year_of_experience"
                  showSearch
                  className="singleSelect"
                  label="Years Of Experience"
                  // disabled={houseHold === "1"}
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select Years Of Experience"
                  rules={[validations.required.select()]}
                  options={{
                    list: userInterestAssessmentDetail?.profile_year_of_experience,
                    valueKey: "id",
                    textKey: "name",
                  }}
                />
              </Col>
            </Row>
          }

        </Space>
      </FormBox>
    </>
  );
};

export default FormComponent;
